/**
 * Redesign Best Sellers Tabs logic
 */
const initBestSellersTabs = () => {
  const sections = document.querySelectorAll('.home-best-sellers');

  sections.forEach(section => {
    const tabs = section.querySelectorAll('.home-best-sellers__tab');
    const contents = section.querySelectorAll('.home-best-sellers__tab-content');

    tabs.forEach(tab => {
      if (tab.getAttribute('data-tab-initialized')) return;
      tab.setAttribute('data-tab-initialized', 'true');

      tab.addEventListener('click', (e) => {
        const tabId = tab.dataset.tabId;

        tabs.forEach(t => {
          t.classList.remove('home-best-sellers__tab--active');
          t.setAttribute('aria-selected', 'false');
        });
        tab.classList.add('home-best-sellers__tab--active');
        tab.setAttribute('aria-selected', 'true');

        contents.forEach(content => {
          if (content.id === `tab-panel-${tabId}`) {
            content.classList.add('home-best-sellers__tab-content--active');

            const carousel = content.querySelector('[data-slick-carousel]');
            if (carousel) {
              const $carousel = $(carousel);
              if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('setPosition');
              } else if (typeof initCustomCarousels === 'function') {
                initCustomCarousels();
              }
            }
          } else {
            content.classList.remove('home-best-sellers__tab-content--active');
          }
        });
      });

      tab.addEventListener('keydown', (e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          tab.click();
        }
      });
    });
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initBestSellersTabs);
} else {
  initBestSellersTabs();
}

document.addEventListener('shopify:section:load', initBestSellersTabs);
